var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechimpactMainlogoClearSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 53.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#76bc21;}.cls-2{fill:#0055b8;}.cls-3{fill:#c1c5c8;}.cls-4{fill:#f18a00;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.15,42.24H81.82a.91.91,0,0,1-.91-.91V37.41a.91.91,0,0,1,.91-.91h20.93a.91.91,0,0,1,.91.91v3.92a.91.91,0,0,1-.91.91H95.42V69.11a.94.94,0,0,1-.91.91H90.06a.94.94,0,0,1-.91-.91Z",
    transform: "translate(-17.99 -26.71)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.16,37.41a.91.91,0,0,1,.91-.91h19.5a.91.91,0,0,1,.91.91v3.92a.91.91,0,0,1-.91.91H114.39V50.1h11.83a.94.94,0,0,1,.91.91v4a.91.91,0,0,1-.91.91H114.39v8.39h14.18a.91.91,0,0,1,.91.91v3.92a.91.91,0,0,1-.91.91h-19.5a.91.91,0,0,1-.91-.91Z",
    transform: "translate(-17.99 -26.71)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.82,36a16.21,16.21,0,0,1,11.59,4.45.89.89,0,0,1,.05,1.34l-2.92,3a.77.77,0,0,1-1.2,0A11.36,11.36,0,0,0,149,42a11.12,11.12,0,0,0,0,22.23,11.5,11.5,0,0,0,7.33-2.73.88.88,0,0,1,1.2,0l3,3.06a.92.92,0,0,1,0,1.3,16.45,16.45,0,0,1-11.64,4.64,17.24,17.24,0,1,1,0-34.48Z",
    transform: "translate(-17.99 -26.71)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165,37.41a.94.94,0,0,1,.91-.91h4.45a.91.91,0,0,1,.91.91V50.1h15.62V37.41a.91.91,0,0,1,.91-.91h4.4a.94.94,0,0,1,.91.91v31.7a.94.94,0,0,1-.91.91h-4.4a.91.91,0,0,1-.91-.91V55.89H171.3V69.11a.91.91,0,0,1-.91.91h-4.45a.94.94,0,0,1-.91-.91Z",
    transform: "translate(-17.99 -26.71)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.46,37.41a.94.94,0,0,1,.91-.91h4.46a.94.94,0,0,1,.91.91v31.7a.94.94,0,0,1-.91.91h-4.46a.94.94,0,0,1-.91-.91Z",
    transform: "translate(-17.99 -26.71)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.75,36.74a.81.81,0,0,1,.86-.72h.77a.86.86,0,0,1,.81.48l10.54,22.6h.15l10.53-22.6a.83.83,0,0,1,.82-.48H242a.8.8,0,0,1,.86.72l5.66,32.18a.83.83,0,0,1-.87,1.1h-4.35a1,1,0,0,1-.91-.72l-2.83-18.15h-.14L231,70a.8.8,0,0,1-.81.53h-.86a.88.88,0,0,1-.82-.53l-8.47-18.82h-.15L217.14,69.3a.94.94,0,0,1-.87.72H212a.88.88,0,0,1-.91-1.1Z",
    transform: "translate(-17.99 -26.71)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.36,37.41a.91.91,0,0,1,.91-.91h11.26a10.68,10.68,0,1,1,.05,21.36h-6V69.11a.94.94,0,0,1-.91.91h-4.41a.91.91,0,0,1-.91-.91ZM265.14,52a4.93,4.93,0,0,0,4.94-5,4.78,4.78,0,0,0-4.94-4.64h-5.55V52Z",
    transform: "translate(-17.99 -26.71)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.28,68.78l14.9-32.24A.86.86,0,0,1,289,36h.48a.81.81,0,0,1,.81.52L305,68.78a.85.85,0,0,1-.82,1.24h-4.17a1.36,1.36,0,0,1-1.38-1l-2.35-5.17H282l-2.35,5.17a1.44,1.44,0,0,1-1.39,1H274.1A.84.84,0,0,1,273.28,68.78ZM294,58.58,289.18,48H289l-4.69,10.54Z",
    transform: "translate(-17.99 -26.71)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.76,36a16.21,16.21,0,0,1,11.59,4.45.89.89,0,0,1,0,1.34l-2.92,3a.77.77,0,0,1-1.2,0A11.36,11.36,0,0,0,322.9,42,11.12,11.12,0,0,0,323,64.23a11.5,11.5,0,0,0,7.33-2.73.88.88,0,0,1,1.2,0l3,3.06a.93.93,0,0,1-.05,1.3,16.45,16.45,0,0,1-11.64,4.64,17.24,17.24,0,1,1,0-34.48Z",
    transform: "translate(-17.99 -26.71)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346.83,42.24H339.5a.91.91,0,0,1-.91-.91V37.41a.91.91,0,0,1,.91-.91h20.93a.91.91,0,0,1,.91.91v3.92a.91.91,0,0,1-.91.91h-7.32V69.11a1,1,0,0,1-.91.91h-4.46a.94.94,0,0,1-.91-.91Z",
    transform: "translate(-17.99 -26.71)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 7.16,
    cy: 26.54,
    r: 7.16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 7.16,
    cy: 45.93,
    r: 7.16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.21,
    cy: 26.54,
    r: 7.16
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.21,
    cy: 45.93,
    r: 7.16
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 7.16,
    cy: 7.16,
    r: 7.16
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.21,
    cy: 7.16,
    r: 7.16
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.68,
    cy: 7.16,
    r: 7.16
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.87,53.46a7.16,7.16,0,1,0-14.32-.21h0V72.44a7.16,7.16,0,1,0,14.32,0Z",
    transform: "translate(-17.99 -26.71)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.58,36.67a6.4,6.4,0,1,1-6.39,6.4A6.43,6.43,0,0,1,371.58,36.67Zm0,11.41a5,5,0,1,0-5-5A5,5,0,0,0,371.58,48.08Zm-2.39-7.94a.34.34,0,0,1,.34-.34h2.76A2.16,2.16,0,0,1,374.48,42a2.07,2.07,0,0,1-1.26,2l.81,1.85a.33.33,0,0,1-.3.48h-1a.38.38,0,0,1-.32-.25l-.78-2h-.93V46a.34.34,0,0,1-.34.34h-.87a.34.34,0,0,1-.34-.34Zm2.9,2.61a.73.73,0,0,0,0-1.46h-1.4v1.46Z",
    transform: "translate(-17.99 -26.71)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechimpactMainlogoClearSpace);
export default __webpack_public_path__ + "static/media/techimpact_mainlogo_clear_space.213833ea1dea9c0a0b408fa3bae3df8a.svg";
export { ForwardRef as ReactComponent };